import { useState, useContext, useEffect } from 'react';

import UserContext from '../../context/UserContext';

import api from '../../services/api';

import apolo from '../../assets/apolo.svg';
import './styles.css';

import { useAlert } from 'react-alert';
import EsqueciSenhaButton from './EsqueciSenhaButton';
import { Button as ShadcnButton } from '../../components/ui/button';
import { InputIcon } from '../../components/ui/input';
import { PersonIcon, LockClosedIcon } from '@radix-ui/react-icons';

function Login() {
  const { userData, setUserData } = useContext(UserContext);
  const alert = useAlert();

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');

  useEffect(() => {
    if (userData.user) {
      window.location.href = process.env.REACT_APP_APPLICATION_URL + 'perfil';
    }
  });

  const submitHandler = async (e) => {
    e.preventDefault();

    try {
      const loginUser = { usuario_colaborador: email, senha };
      const loginRes = await api.post('/api/user/login', loginUser);

      setUserData({
        token: loginRes.data.token,
        user: loginRes.data.user,
      });

      // Salva o token e o ID do usuário no localStorage
      localStorage.setItem('auth-token', loginRes.data.token);
      localStorage.setItem('userId', loginRes.data.user.id);

      window.location.href = process.env.REACT_APP_APPLICATION_URL + 'perfil';
    } catch (err) {
      alert.show('Erro ao fazer login. Por favor, tente novamente.', {
        title: 'Algo deu errado.',
        closeCopy: 'OK',
      });
    }
  };

  return (
    <div className="login-container">
      <div className="logo">
        <div
          style={{
            height: '80%',
            width: '97%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
          }}
        >
          <img src={apolo} alt="Meu perfil" width="1000px" />
        </div>
        <div
          className="retangulo"
          style={{
            width: '50vw',
            height: '40px',
            flexShrink: '0',
            backgroundColor: '#D9D9D9',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: '30.17px',
            color: '#00293B',
            display: 'flex',
            justifyContent: 'center',
            marginTop: '107px',
            alignItems: 'center',
          }}
        >
          By Xerlock Smart Gov
        </div>
      </div>
      <div className="form-container">
        <form onSubmit={submitHandler}>
          <div className="flex flex-col w-10/12 mx-4 gap-8">
            <h1
              style={{
                fontSize: '40px',

                fontWeight: 400,
                lineHeight: '75.42px',
                color: '#00293B',
                align: 'center',
              }}
            >
              Fazer login em sua conta
            </h1>

            <InputIcon
              placeholder="nome de usuário"
              className="border-[#00293B]"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              icon={<PersonIcon className="h-[18px] w-[16px]" />}
            />

            <InputIcon
              type="password"
              placeholder="senha"
              className="border-[#00293B]"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              icon={<LockClosedIcon className="h-[18px] w-[16px]" />}
            />

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end',
                flexDirection: 'row-reverse',
                marginTop: '-1.5rem',
              }}
            >
              <ShadcnButton type="submit" className="text-lg px-6 py-4">
                Entrar
              </ShadcnButton>

              <EsqueciSenhaButton />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
